import { render, staticRenderFns } from "./passwordRecovery.vue?vue&type=template&id=4d05d726&scoped=true"
import script from "./passwordRecovery.vue?vue&type=script&lang=js"
export * from "./passwordRecovery.vue?vue&type=script&lang=js"
import style0 from "./passwordRecovery.vue?vue&type=style&index=0&id=4d05d726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d05d726",
  null
  
)

export default component.exports